import { Reveal, Eyebrow } from "./Reveal";
import { SIZE_PRICING, DIFFICULTY, CLEANUP_UPSELLS, STANDARD_SERVICE } from "../lib/site";

const Row = ({ left, right, testid }) => (
    <div
        data-testid={testid}
        className="flex items-center justify-between gap-4 px-5 sm:px-7 py-4 border-b border-brand-line last:border-b-0 hover:bg-brand-elevated/60 transition-colors"
    >
        <span className="font-mono text-brand-cream text-sm sm:text-base">{left}</span>
        <span className="font-mono font-bold text-brand-amber text-sm sm:text-lg">{right}</span>
    </div>
);

const SpecTable = ({ eyebrow, title, note, children, testid }) => (
    <Reveal className="mb-20">
        <div className="mb-6">
            <Eyebrow className="mb-3">{eyebrow}</Eyebrow>
            <h2 className="font-display font-black uppercase text-brand-cream text-3xl sm:text-4xl tracking-tight">
                {title}
            </h2>
            {note && <p className="text-brand-sage text-sm mt-2 max-w-xl">{note}</p>}
        </div>
        <div
            data-testid={testid}
            className="rounded-lg border border-brand-line bg-brand-surface overflow-hidden"
        >
            {children}
        </div>
    </Reveal>
);

const PricingTables = () => (
    <div className="max-w-4xl mx-auto px-5 sm:px-8" data-testid="pricing-tables">
        <SpecTable
            eyebrow="Spec 01 — Base price"
            title="Pricing by stump size"
            note="Starting prices by stump diameter, measured across the root flare at ground level. Not sure of your size? Send a photo with your free quote and we'll size it."
            testid="pricing-spec-table"
        >
            <div className="grid grid-cols-2 px-5 sm:px-7 py-3 border-b border-brand-line bg-brand-elevated/70">
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-moss">
                    Stump size
                </span>
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-moss text-right">
                    Starting
                </span>
            </div>
            {SIZE_PRICING.map((r) => (
                <Row key={r.size} left={r.size} right={`$${r.price}`} testid={`price-row-${r.size.replace('"', '-inch')}`} />
            ))}
            <p className="px-5 sm:px-7 py-4 font-mono text-[11px] text-brand-moss uppercase tracking-wider">
                Stump wider than 70"? Call — we'll price it on site.
            </p>
        </SpecTable>

        <SpecTable
            eyebrow="Spec 02 — Difficulty"
            title="Situation & access add-ons"
            note="Root flare and access are legitimate pricing factors — narrow gates, structures, and big surface-root systems all change the work."
            testid="pricing-difficulty-table"
        >
            <div className="grid grid-cols-2 px-5 sm:px-7 py-3 border-b border-brand-line bg-brand-elevated/70">
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-moss">
                    Situation
                </span>
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-moss text-right">
                    Add
                </span>
            </div>
            {DIFFICULTY.map((r) => (
                <Row key={r.label} left={r.label} right={r.add} testid={`difficulty-row-${r.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />
            ))}
        </SpecTable>

        <SpecTable
            eyebrow="Spec 03 — Cleanup"
            title="Cleanup services"
            testid="pricing-cleanup-table"
        >
            <div className="px-5 sm:px-7 py-5 border-b border-brand-line bg-brand-forest/40">
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#75E29A] mb-2">
                    Included in every job
                </p>
                <p className="font-bold text-brand-cream text-base sm:text-lg">
                    {STANDARD_SERVICE}
                </p>
            </div>
            <div className="grid grid-cols-2 px-5 sm:px-7 py-3 border-b border-brand-line bg-brand-elevated/70">
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-moss">
                    Optional service
                </span>
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-moss text-right">
                    Charge
                </span>
            </div>
            {CLEANUP_UPSELLS.map((r) => (
                <Row key={r.label} left={r.label} right={r.add} testid={`cleanup-row-${r.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />
            ))}
        </SpecTable>
    </div>
);

export default PricingTables;
